import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ServiceHero from '../../components/services/ServiceHero';
import ServiceContent from '../../components/services/ServiceContent';
import ServiceCTA from '../../components/services/ServiceCTA';

const ProductDevelopment = () => {
  const serviceData = {
    title: 'Product Development',
    subtitle: 'End-to-end digital product creation',
    description: 'We transform your ideas into market-ready products. From initial concept to launch and beyond, our team handles every aspect of product development with precision and expertise.',
    sections: [
      {
        heading: 'Our Product Development Process',
        items: [
          {
            title: 'Discovery & Strategy',
            description: 'We start by understanding your vision, target audience, and business goals. Through workshops and research, we define product requirements and create a comprehensive roadmap.',
            icon: 'Lightbulb'
          },
          {
            title: 'Design & Prototyping',
            description: 'Our designers create intuitive user experiences and stunning interfaces. We build interactive prototypes to validate concepts before development begins.',
            icon: 'Palette'
          },
          {
            title: 'Development & Testing',
            description: 'Using agile methodologies, we build your product with clean, scalable code. Continuous testing ensures quality at every stage of development.',
            icon: 'Code'
          },
          {
            title: 'Launch & Support',
            description: 'We handle deployment, monitoring, and provide ongoing support to ensure your product succeeds in the market.',
            icon: 'Rocket'
          }
        ]
      }
    ],
    capabilities: [
      'Web Application Development',
      'Mobile App Development (iOS & Android)',
      'Progressive Web Apps (PWA)',
      'API Development & Integration',
      'Cloud Infrastructure Setup',
      'DevOps & CI/CD Implementation',
      'Quality Assurance & Testing',
      'Performance Optimization',
      'Post-Launch Support & Maintenance'
    ],
    technologies: ['React', 'React Native', 'Node.js', 'Python', 'PostgreSQL', 'MongoDB', 'AWS', 'Docker', 'Kubernetes']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Product Development Services"
        description="End-to-end product development — from concept to launch. We build scalable web and mobile applications using React, Node.js, Python, and cloud infrastructure."
        path="/services/product-development"
      />
      <Header />
      <ServiceHero data={serviceData} />
      <ServiceContent data={serviceData} />
      <ServiceCTA service="Product Development" />
      <Footer />
    </div>
  );
};

export default ProductDevelopment;
